import { BrandPriceList, RequestHeaderData } from "@NA/Store/Data/ADIRequestPriceListState";
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, ServiceResult, get, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";


export interface PriceListRequestparams extends ApiParameter {
    brandId: string;
    brandName: string;
}
export interface PriceListHeaderModel {
    requestVersion: string;
    requestId: string;
    customerNumber: string;
    userID: string;
    userEmail: string;
    returnCode: string;
    returnMessage: string;
    recordCount: string;
}
export interface PriceListRequestCollectionModel extends BaseModel {
    status?: number;
    RequestHeader: RequestHeaderData;
    BrandsRequested: BrandPriceList[];
}
export interface PriceListResponseModel extends BaseModel {
    requestHeader: PriceListHeaderModel;
}

export interface LoggerParameterModel {
    CurrentMethod: string;
    MessageType: string;
    Message: any;
    Source: string;
    onSuccess?: (result: any) => void;
}

const priceListUri = "/api/v1/priceListRequest";
const loggerUri = "/api/v1/Logger";

export async function getPriceListRequest(parameter: PriceListRequestparams) {
    let result: any = null;
    try {
        result = await post<PriceListRequestCollectionModel>(`${priceListUri}`, parameter as any);
        if (result.status === 403) {
            const logparameter: LoggerParameterModel = { CurrentMethod: "PriceListRequest", MessageType: "Error", Message: "Forbidden: Access denied", Source: "Price List Request" };
            await Logger(logparameter as LoggerParameterModel);
        }

        return result;
    } catch (error) {
        let errormessage = await decodeHtml(error.errorMessage);
        // if(errormessage.indexOf("Cloudflare Ray ID") != -1) {
        if (error.status === 403) {
            const logparameter: LoggerParameterModel = { CurrentMethod: "PriceListRequest", MessageType: "Error", Message: errormessage, Source: "Price List Request" };
            await Logger(logparameter as LoggerParameterModel);
            result = {
                success: false,
                errorMessage: errormessage || "An unknown error occurred",
                errorDetail: error,
            };
        }
        return result;

    }
}

export async function Logger(logparameter: LoggerParameterModel) {
    return await post<any>(`${loggerUri}`, logparameter as LoggerParameterModel);
}

export async function decodeHtml(html: string) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return await txt.value;
}
